export default __webpack_public_path__ + "static/media/LOOCAL.85473f78.png";